/**
 * next-translate locale -> the locale the plans API and the section's own copy
 * dictionaries key on. Two of this app's locale codes are the non-standard
 * ones (`jp`, `kr`); `id` has no catalogue upstream and falls back to English,
 * which is what the section already does for an unknown locale.
 */
const LOCALE_ALIASES: Record<string, string> = { jp: 'ja', kr: 'ko' };

const SUPPORTED_LOCALES = new Set([
  'en',
  'fr',
  'es',
  'de',
  'ja',
  'ar',
  'ko',
  'it',
  'pt',
  'tr',
  'ru',
]);

export function resolveGlassLocale(locale?: string): string {
  if (!locale) return 'en';
  const mapped = LOCALE_ALIASES[locale] ?? locale;
  return SUPPORTED_LOCALES.has(mapped) ? mapped : 'en';
}
